import './ProgressBar.css';

export type ProgressBarType = 'default' | 'success' | 'error' | 'disabled';

/** Horizontal progress bar with an optional percentage label. Supports default, success, error, and disabled types. */
export type ProgressBarProps = {
  /** Percentage complete (0–100). Clamped to range. */
  value?: number;
  type?: ProgressBarType;
  showPercentage?: boolean;
  /** Stretch to the container's width instead of stopping at 234px. */
  fill?: boolean;
  className?: string;
};

export function ProgressBar({
  value = 0,
  type = 'default',
  showPercentage = true,
  fill = false,
  className = '',
}: ProgressBarProps) {
  const clamped = Math.min(100, Math.max(0, value));
  const disabled = type === 'disabled';

  const rootClasses = [
    'spark-progress-bar',
    `spark-progress-bar-type-${type}`,
    fill ? 'spark-progress-bar--full-width' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div
      className={rootClasses}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={clamped}
      aria-disabled={disabled || undefined}
    >
      <div className="spark-progress-bar-track">
        <div className="spark-progress-bar-fill" style={{ width: `${clamped}%` }} />
      </div>
      {showPercentage ? <span className="spark-progress-bar-label">{clamped}%</span> : null}
    </div>
  );
}
